import { EMPTY_SEARCH_SUGGESTION_QUERY_KEY } from "@faire/deprecated-retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/__internal__/getSearchSuggestionsQueryKey";
import { ISearchSuggestionResponse } from "@faire/web-api--source/indigofair/data/ISearchSuggestionResponse";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const useSearchSuggestionsUpdateRecentSearchesQueries = (
  action: "delete" | "add"
) => {
  const queryClient = useQueryClient();

  return useCallback(
    (query: string) => {
      queryClient.setQueryData<ISearchSuggestionResponse>(
        EMPTY_SEARCH_SUGGESTION_QUERY_KEY,
        (oldQueryData) => {
          if (oldQueryData === undefined) {
            return oldQueryData;
          }

          return ISearchSuggestionResponse.build({
            ...oldQueryData,
            recent_searches: getUpdatedRecentSearches(
              action,
              query,
              oldQueryData?.recent_searches ?? []
            ),
          });
        }
      );

      void queryClient.invalidateQueries({
        queryKey: EMPTY_SEARCH_SUGGESTION_QUERY_KEY,
        refetchType: "none",
      });
    },
    [action, queryClient]
  );
};

const getUpdatedRecentSearches = (
  action: "delete" | "add",
  query: string,
  original: string[]
) => {
  const doesNotMatchQuery = (originalQuery: string) => originalQuery !== query;

  if (action === "add") {
    return [query, ...original.filter(doesNotMatchQuery)];
  }

  return original.filter(doesNotMatchQuery);
};
